import { render } from "./FormatIndentIncrease.vue?vue&type=template&id=bd8a2cd6"
import script from "./FormatIndentIncrease.vue?vue&type=script&lang=js"
export * from "./FormatIndentIncrease.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__